exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".platform-decoration-dialog .el-range-separator{padding:0 10px;min-width:46px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-136541b0!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/views/OperationManage/UserAdminister/PlatformDecoration/PlatformDecoration.vue
// module id = 445
// module chunks = 0